import { c as _c } from "react/compiler-runtime";
import { CurrencyEnum, FormSelect } from '@systemeio/ui';
import { usePhysicalProductsList } from 'modules/funnels/funnel/components/step-configuration-tab/physical-product-selector/hooks/use-physical-products-list';
import { getProductListData } from 'modules/funnels/funnel/utils/offer-configuration-utils';
import ItemSteps from 'modules/stores/store/components/item-steps';
import React, { Dispatch, SetStateAction } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { PhysicalProductItemEditType } from '../../types/product-interface';
interface PhysicalProductProps {
  tempState: PhysicalProductItemEditType;
  setTempState: Dispatch<SetStateAction<PhysicalProductItemEditType>>;
  currency: CurrencyEnum;
  physicalProductSelectorError?: string;
}
const PhysicalProduct = t0 => {
  const $ = _c(15);
  const {
    tempState,
    setTempState,
    currency,
    physicalProductSelectorError
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    physicalProductsList,
    isLoading
  } = usePhysicalProductsList(currency);
  let t1;
  if ($[0] !== setTempState) {
    t1 = value => {
      if (!value) {
        return;
      }
      setTempState(prevState => ({
        ...prevState,
        checkoutPage: {
          ...prevState.checkoutPage,
          physicalProductId: value
        }
      }));
    };
    $[0] = setTempState;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onChangePhysicalProduct = t1;
  let t2;
  if ($[2] !== t) {
    t2 = t("dashboard.store.item.physical_product.title");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== physicalProductsList) {
    t3 = physicalProductsList && getProductListData(physicalProductsList);
    $[4] = physicalProductsList;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== isLoading || $[7] !== onChangePhysicalProduct || $[8] !== physicalProductSelectorError || $[9] !== t3 || $[10] !== tempState.checkoutPage.physicalProductId) {
    t4 = <FormSelect isPreFetching={isLoading} value={tempState.checkoutPage.physicalProductId} data={t3} onChange={onChangePhysicalProduct} error={physicalProductSelectorError} withoutCloseIcon={true} />;
    $[6] = isLoading;
    $[7] = onChangePhysicalProduct;
    $[8] = physicalProductSelectorError;
    $[9] = t3;
    $[10] = tempState.checkoutPage.physicalProductId;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t2 || $[13] !== t4) {
    t5 = <ItemSteps steps={[{
      key: "physicalProductSelect",
      title: t2,
      element: t4
    }]} />;
    $[12] = t2;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};
export default PhysicalProduct;